export const ORIENTATION = {
  horizontal: 'horizontal',
  vertical: 'vertical',
};

export const SPACING = {
  spacing2XS: 'spacing-2-xs',
  spacingM: 'spacing-m',
};
